export default {
  whistle: 'text-activity-sport',
  flag: 'text-activity-learn',
  confetti: 'text-activity-outing',
  'coffee-cup': 'text-activity-relax',
};

const ICON_TO_ACTIVITY_BG = {
  whistle: 'activity-sport',
  flag: 'activity-learn',
  confetti: 'activity-outing',
  'coffee-cup': 'activity-relax',
};

const ICON_TO_ACTIVITY = {
  whistle: 'activity-sport',
  flag: 'activity-learn',
  confetti: 'activity-outing',
  'coffee-cup': 'activity-relax',
};

export { ICON_TO_ACTIVITY, ICON_TO_ACTIVITY_BG };
